import './App.css';
import Hero from './components/Hero';
import Servicios from './components/Servicios';
import Historia from './components/Historia';
import Resenas from './components/Reseñas';
import Mapa from './components/Mapa';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Hero />
      <Servicios />
      <Historia />
      <Resenas />
      <Mapa />
      <Footer />
    </>
  );
}

export default App;